import React from 'react';
import { Alert, Link, Typography } from '@mui/material';

import { websiteProfileUrlBase } from '@env';
import { formatExternalUrl } from '@utils/parsing';

export type RecommendKind = 'created' | 'already_exists' | 'self' | 'unverified' | 'error';

export type RecommendState = {
    kind: RecommendKind,
    name: string,
    slug: string | null
};

function websiteProfileHref(slug: string | null): string | null {
    if (!slug || !websiteProfileUrlBase) return null;
    const base = String(websiteProfileUrlBase).replace(/\/$/, '');
    return formatExternalUrl(`${base}/${slug}`);
}

function RecommendBackLink({ href }: { href: string }) {
    return (
        <Link href={href}>
            hemsidans profil
        </Link>
    );
}

export default function RecommendResultBanner({ state }: { state: RecommendState }) {
    const href = websiteProfileHref(state.slug);
    const back = href
        ? (
            <>
                {' Du kan nu gå tillbaka till '}
                <RecommendBackLink href={href} />
                .
            </>
        )
        : null;

    const severity = state.kind === 'created' || state.kind === 'already_exists' ? 'success' : 'info';

    let body: React.ReactNode;
    if (state.kind === 'created') {
        body = (
            <>
                Du har rekommenderat
                {' '}
                <strong>{state.name}</strong>
                .
                {back}
            </>
        );
    } else if (state.kind === 'already_exists') {
        body = (
            <>
                Ditt företag har redan rekommenderat
                {' '}
                <strong>{state.name}</strong>
                .
                {back}
            </>
        );
    } else if (state.kind === 'self') {
        body = (
            <>
                Du kan inte rekommendera ditt eget företag.
                {back}
            </>
        );
    } else if (state.kind === 'unverified') {
        body = (
            <>
                Bara verifierade åkerier kan rekommenderas.
                {back}
            </>
        );
    } else {
        body = (
            <>
                Något gick fel när rekommendationen skulle sparas.
                {back}
            </>
        );
    }

    return (
        <Alert severity={severity} sx={{ mb: 2 }}>
            <Typography variant="body2" component="div">
                {body}
            </Typography>
        </Alert>
    );
}
